import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Loader, LoaderContainer } from '../../Loader';
import './TitleXsSm.css';

const TitleXsSm = (props) => {

  if (props.loading) {
    return (
      <Row>
        <Col sm={12} className="visible-xs">
          <LoaderContainer>
            <Loader sizes={[100, 40]} spacer={5} />
            <Loader sizes={[70, 20]} spacer={40} />
          </LoaderContainer>
        </Col>
        <Col sm={12} className="visible-sm">
          <LoaderContainer>
            <Loader sizes={[100, 40]} spacer={5} />
            <Loader sizes={[30, 10]} spacer={20} />
          </LoaderContainer>
        </Col>
      </Row>
    );
  }
  else {
    return (
      <Row className="fademein visible-xs visible-sm text-center">
        <Col sm={12} className="TitleXsSm__ctn">
          {props.count > 1 ?
            <div className="hidden-xs">
              <Link to={`/${props.project.category}/${props.navProjectIds.prev}`}>
                <FontAwesomeIcon icon={faChevronLeft} size="2x" />
              </Link>
            </div>
            : null
          }

          <div className="TitleXsSm__header">
            <div className="TitleXsSm__title">Project: <strong>{props.project.title}</strong></div>
            {props.project.subtitle &&
              <div className="TitleXsSm__subtitle">{props.project.subtitle}</div>
            }
            <a className="TitleXsSm__url" href={props.project.url} target="_blank">{props.project.url}</a>
          </div>


          {props.count > 1 ?
            <div className="hidden-xs">
              <Link to={`/${props.project.category}/${props.navProjectIds.next}`}>
                <FontAwesomeIcon icon={faChevronRight} size="2x" />
              </Link>
            </div>
            : null
          }

        </Col>
      </Row>
    )
  }
}

export default TitleXsSm;


// WEBPACK FOOTER //
// ./src/components/Project/TitleXsSm/TitleXsSm.js